import { Injectable } from '@angular/core';
import {from, map, Observable, of} from 'rxjs';
import {get, post, patch} from 'aws-amplify/api';

export interface ICustomer {
  _id: string;
  name: string;
  voucher: string;
  usesLeft: number;
  vouchersBought: number;
  accountsUsingCode: string[];
  _createdAt?: Date;
  _updatedAt?: Date;
}

export type CustomerListQuery = {
  page: number;
  pageSize: number;
};

export type CustomerListResponse = {
  customers: ICustomer[];
  totalRecords: number;
  page: number;
  pageSize: number;
};

@Injectable({ providedIn: 'root' })
export class CustomersService {

  listCustomers(query: CustomerListQuery): Observable<CustomerListResponse> {
    const first = (query.page - 1) * query.pageSize;

    return from(
      get({
        apiName: 'API',
        path: 'customer',
        options: {
          queryParams: {
            rows: String(query.pageSize),
            first: String(first)
          }
        }
      }).response.then((res: any) => res.body.json())
      ).pipe(
          map((res: any) => {
            return {
              customers: res.customers,
              totalRecords: toNumber(res.totalRecords ?? res.total ?? res.count),
              page: query.page,
              pageSize: query.pageSize
            };
          })
      );
  }

  addVouchers(customer: ICustomer, quantity: number): Observable<any> {
    return of(
      patch({
        apiName: 'API',
        path: 'customer',
        options: {
          body: {
            customerId: customer._id,
            vouchersToAdd: quantity
          }
        }
      }).response.then((res: any) => res.body.json()));
  }

  createCustomer(customer: ICustomer): Observable<any> {
    return of(
      post({
        apiName: 'API',
        path: 'customer',
        options: {
          body: {
            customer: customer as any
          }
        }
      }).response.then((res: any) => res.body.json()));
  }
}

function toNumber(value: unknown): number {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}
